/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { sendRequestAndReceiveResponse, filterNames, filterModels, toFileNameLookupBody } from '../common/common';
import { getServiceManualDetailonNameEndPoint } from '../common/constants';

const UPDATE_SELECTED_FAMILIES = 'UPDATE_SELECTED_FAMILIES';
const UPDATE_SELECTED_PRODUCTNAMES = 'UPDATE_SELECTED_PRODUCTNAMES';
const UPDATE_SELECTED_PRODUCTMODELS = 'UPDATE_SELECTED_PRODUCTMODELS';
const MANUAL_INFORMATION_CHANGE = 'MANUAL_INFORMATION_CHANGE';
const RELEASE_DATE_CHANGE = 'RELEASE_DATE_CHANGE';
const UPDATE_DOCUMENT_CATEGORIES = 'UPDATE_DOCUMENT_CATEGORIES';
const UPDATE_HELP_BUTTONS = 'UPDATE_HELP_BUTTONS';
const HELP_LINKS_CHANGE = 'HELP_LINKS_CHANGE';
const SERVICE_MANUAL = 'SERVICE_MANUAL';
const CLEAR_UPLOAD_MANUAL_STORE = 'CLEAR_UPLOAD_MANUAL_STORE';
const HANDLE_UPLOAD_DIALOG_CLICK = 'HANDLE_UPLOAD_DIALOG_CLICK';
const UPDATE_EDIT_MANUAL_DATA = 'UPDATE_EDIT_MANUAL_DATA';
const UPDATE_FILE_NAME = 'UPDATE_FILE_NAME';
const UPDATE_EDIT_MANUAL_DATA_USING_UPLOAD = 'UPDATE_EDIT_MANUAL_DATA_USING_UPLOAD';
const LOADING_MANUAL_DETAIL_ON_NAME = 'LOADING_MANUAL_DETAIL_ON_NAME';
const UPDATE_UPLOAD_FAMILIES = 'UPDATE_UPLOAD_FAMILIES';
const UPDATE_UPLOAD_NAMES = 'UPDATE_UPLOAD_NAMES';
const UPDATE_UPLOAD_MODELS = 'UPDATE_UPLOAD_MODELS';
const colors: Array<string> = ['#CFE1EE', '#DFE9D6', '#FFF2CC', '#FFE8CC', '#F4D1D3'];


const initialState = {
    data: {},
    releaseDate: new Date(new Date().setDate(15)),
    documentCategories: [],
    documentCategory: 0,
    helpButtons: [],
    uploadDialogOpen: false,
    isDetailLoadingOnManualName: false,
    uploadDetails: { families: [], productNames: [], productModels: [] },
    isFileChanged: false,
    isEdit: false
}


export const actionCreators = {

    UpdateUploadFamilies: (families: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_UPLOAD_FAMILIES, families });
    },
    UpdateSelectedFamilies: (selectedFamilies: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SELECTED_FAMILIES, selectedFamilies });
    },
    FilterUploadNames: (productFamilies: any, selectedFamilies: any) => async (dispatch: any, getState: any) => {
        const productNames: any = filterNames(productFamilies, selectedFamilies);
        dispatch({ type: UPDATE_UPLOAD_NAMES, productNames });
    },
    UpdateSelectedProductNames: (SelectedProductNames: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SELECTED_PRODUCTNAMES, SelectedProductNames });
    },
    FilterUploadModels: (productNames: any, selectedProductNames: any) => async (dispatch: any, getState: any) => {
        const productModels: any = filterModels(productNames, selectedProductNames);
        dispatch({ type: UPDATE_UPLOAD_MODELS, productModels });
    },
    UpdateSelectedProductModels: (SelectedProductModels: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SELECTED_PRODUCTMODELS, SelectedProductModels });
    },
    handleManualInformationChange: (event: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: MANUAL_INFORMATION_CHANGE, event });
    },
    handlereleaseDateChange: (date: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: RELEASE_DATE_CHANGE, date });
    },
    UpdateDocumentCategories: (data: any) => async (dispatch: any, getState: any) => {
        const x: any = [{ id: 0, name: 'No entry' }].concat(data);
        dispatch({ type: UPDATE_DOCUMENT_CATEGORIES, x });
    },
    UpdateHelpButtons: (data: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_HELP_BUTTONS, data });
    },
    handleHelpLinksChange: (event: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: HELP_LINKS_CHANGE, event });
    },
    UpdateSelectedPdf: (selectedPdf: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: SERVICE_MANUAL, selectedPdf });
    },
    clearAll: () => async (dispatch: any, getState: any) => {
        dispatch({ type: CLEAR_UPLOAD_MANUAL_STORE });
    },
    handleUploadDialogClick: (isOpen: boolean) => async (dispatch: any, getState: any) => {
        dispatch({ type: HANDLE_UPLOAD_DIALOG_CLICK, isOpen });
    },
    UpdateEditManualData: (serviceManualData: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_EDIT_MANUAL_DATA, serviceManualData });
    },
    UpdateFileName: (fileName: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_FILE_NAME, fileName });
        let a = { value: true };
        dispatch({ type: LOADING_MANUAL_DETAIL_ON_NAME, a });
        const serviceManualData = await sendRequestAndReceiveResponse(toFileNameLookupBody(fileName), getServiceManualDetailonNameEndPoint);
        if (serviceManualData.serviceManualId != undefined) {
            await dispatch({ type: UPDATE_EDIT_MANUAL_DATA_USING_UPLOAD, serviceManualData });
        }
        a = { value: false };
        dispatch({ type: LOADING_MANUAL_DETAIL_ON_NAME, a });
    }
}


const getColors = (parentArray: any, selectedArray: any, fillArrayName: any) => {
    const selectedColors: any = [];
    parentArray.map((x: any) => {
        const a: any = selectedArray.indexOf(x.id);
        if (a != -1) {
            if (fillArrayName != '') {
                x.color = colors[a % colors.length];
                x[fillArrayName].forEach((y: any) => {
                    y.color = x.color;
                });
            }
            selectedColors.push(x.color);
        }
    });
    return selectedColors;
}
const getProductNames = (families: any, smd: any) => {
    const productNames: any = [];
    smd.familyData.forEach((family: any) => {
        const a = filterNames(families, [family.productFamilyId]);
        a.forEach((v: any) => {
            productNames.push(v);
        });
    });

    return productNames;
}

const getEditManualData = (smd: any) => {
    const names: any = [];
    const productmodels: any = [];
    const families: any = [];
    smd.familyData.forEach((x1: any) => {
        families.push(x1.productFamilyId);
        x1.nameList.forEach((x: any) => {
            names.push(x.productNameId);
            x.modelList.forEach((y: any) => {
                productmodels.push(y.productModelId);
            });
        });
    });
    let hlas: any = [];
    if (smd.helpButtons != null && smd.helpButtons != undefined && smd.helpButtons.length) {
        smd.helpButtons.forEach((x: any) => {
            hlas = { ...hlas, [x.helpButtonTypeid]: x.pageNumber };
        });
    }
    return { names, productmodels, hlas, families };
}

export const reducer = (state: any, action: any) => {
    state = state || initialState;

    switch (action.type) {
        case UPDATE_SELECTED_FAMILIES:
            return {
                ...state,
                selectedFamilies: action.selectedFamilies
            };
        case UPDATE_SELECTED_PRODUCTNAMES: {
            const selectedNameColors: any = getColors(state.uploadDetails.productNames, action.SelectedProductNames, 'twodproductmodels');
            return {
                ...state,
                selectedProductNames: action.SelectedProductNames,
                selectedNameColors
            };
        }
        case UPDATE_SELECTED_PRODUCTMODELS: {
            const selectedModelColors: any = getColors(state.uploadDetails.productModels, action.SelectedProductModels, '');
            let dn: any = '';

            if (state.isFileChanged || state.isEdit) {
                dn = state.displayName;
            }
            else {
                let tempstring: any = '';
                state.uploadDetails.productModels.map((x: any) => {
                    if (action.SelectedProductModels.indexOf(x.id) != -1) {
                        tempstring += ', ' + x.name;
                    }
                });
                dn = tempstring.substring(1);
            }

            return {
                ...state,
                selectedProductModels: action.SelectedProductModels,
                selectedModelColors,
                displayName: dn
            };
            }
        case MANUAL_INFORMATION_CHANGE:
            return {
                ...state,
                [action.event.target.name]: action.event.target.value
            };
        case RELEASE_DATE_CHANGE:
            return {
                ...state,
                releaseDate: (action.date == null || action.date == undefined) ? null : new Date(new Date(action.date).setDate(15)),
            };
        case UPDATE_DOCUMENT_CATEGORIES:
            return {
                ...state,
                documentCategories: action.x
            };
        case UPDATE_HELP_BUTTONS:
            return {
                ...state,
                helpButtons: action.data
            };
        case HELP_LINKS_CHANGE:
            return {
                ...state,
                helpLinkAssignments: {
                    ...state.helpLinkAssignments, [action.event.target.id]: parseInt(action.event.target.value)
                }
            };
        case SERVICE_MANUAL:
            return {
                ...state,
                selectedPdf: action.selectedPdf
            };
        case CLEAR_UPLOAD_MANUAL_STORE:
            return initialState;
        case HANDLE_UPLOAD_DIALOG_CLICK:
            return {
                ...state,
                uploadDialogOpen: action.isOpen
            };
        case UPDATE_EDIT_MANUAL_DATA: {
            const smd = action.serviceManualData;
            console.log(action);
            const editManualData = getEditManualData(smd);
            return {
                ...state,
                selectedPdf: smd.presignedURL,
                selectedFamilies: editManualData.families,
                selectedProductNames: editManualData.names,
                selectedProductModels: editManualData.productmodels,
                originalProductModels: JSON.parse(JSON.stringify(editManualData.productmodels)),
                serviceManualPartNo: smd.serviceManualPartnumber,
                displayName: smd.displayName,
                fileName: smd.name,
                documentCategory: smd.serviceManualTypeId,
                revision: smd.revision,
                releaseDate: (smd.dateOfIssue == null || smd.dateOfIssue == undefined) ? null : new Date(smd.dateOfIssue),
                helpLinkAssignments: editManualData.hlas,
                isEdit: true
            };
            }
        case UPDATE_FILE_NAME:
            return {
                ...state,
                fileName: action.fileName
            };
        case LOADING_MANUAL_DETAIL_ON_NAME:
            return {
                ...state,
                isDetailLoadingOnManualName: action.a.value
            };
        case UPDATE_EDIT_MANUAL_DATA_USING_UPLOAD: {
            const smd = action.serviceManualData;
            const names = getProductNames(state.uploadDetails.families, smd);
            console.log(names);
            const editManualData = getEditManualData(smd);
            const models = filterModels(names, editManualData.names);
            console.log(models);
            const selectedNameColors = getColors(names, editManualData.names, 'twodproductmodels');
            const selectedModelColors = getColors(models, editManualData.productmodels, '');
            return {
                ...state,
                uploadDetails: { ...state.uploadDetails, productNames: names, productModels: models },
                selectedFamilies: editManualData.families,
                selectedProductNames: editManualData.names,
                selectedProductModels: editManualData.productmodels,
                originalProductModels: JSON.parse(JSON.stringify(editManualData.productmodels)),
                serviceManualPartNo: smd.serviceManualPartnumber,
                displayName: smd.displayName,
                fileName: smd.name,
                documentCategory: smd.serviceManualTypeId,
                revision: smd.revision,
                releaseDate: (smd.dateOfIssue == null || smd.dateOfIssue == undefined) ? null : new Date(smd.dateOfIssue),
                helpLinkAssignments: editManualData.hlas,
                isDetailLoadingOnManualName: false,
                selectedNameColors,
                selectedModelColors,
                isFileChanged: true
            };
            }
        case UPDATE_UPLOAD_FAMILIES:
            return {
                ...state,
                uploadDetails: { ...state.uploadDetails, families: action.families }
            };
        case UPDATE_UPLOAD_NAMES:
            return {
                ...state,
                uploadDetails: { ...state.uploadDetails, productNames: action.productNames }
            };
        case UPDATE_UPLOAD_MODELS:
            return {
                ...state,
                uploadDetails: { ...state.uploadDetails, productModels: action.productModels }

            };
    }
    return state;
};
